// extracted by mini-css-extract-plugin
export default {"base":"ComputableColumn__base___yw18IpJm"};